// Separator for the internal cell-map key `term|downPayment|balloonBracket`
export const RATE_MATRIX_CELL_KEY_SEPARATOR = '|';
